import { initializeApp } from 'firebase/app';

import {
  getFirestore,
} from 'firebase/firestore';

import {
  getAuth,
} from 'firebase/auth';

const firebaseConfig = {
  apiKey:  "AIzaSyDtt0xNg19JBC4uD8EeoLCodg2__Z8VscM",
  authDomain: "fivetry-d8b19.firebaseapp.com",
  projectId: "fivetry-d8b19",
  storageBucket: "fivetry-d8b19.firebasestorage.app",
  messagingSenderId: "43879467703",
  appId: "1:43879467703:web:a55a62586865570a3c5b32"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);

export const auth = getAuth(app);